'use client';

import React from 'react';
import clsx from 'clsx';
import {useRouter, useSearchParams} from 'next/navigation';

import {FilterAccordion} from '@/modules/commerce/filters/FilterAccordion';

import {Checkbox} from '../form/Checkbox';
import {Select} from '../form/Select';

interface FilterOption {
	label: string;
	value: string;
}

export interface FilterConfig {
	id: string;
	label: string;
	options: FilterOption[];
	multiple?: boolean;
	color?: boolean;
}

const ClientFilters = ({filterConfigs}: {filterConfigs: (FilterConfig | null)[]}) => {
	const router = useRouter();
	const searchParams = useSearchParams();

	// FIXME: add custom input for color selection, horrible solution for now
	return (
		<FilterAccordion>
			<form
				method="get"
				className={clsx('mt-2', 'flex', 'gap-4', 'flex-wrap')}
				onChange={(e) => {
					// Update the page search params with the new filter state:
					const formData = new FormData(e.currentTarget);
					const newSearchParams = new URLSearchParams();

					for (const filterConfig of filterConfigs) {
						if (!filterConfig) {
							continue;
						}

						const {id, multiple = false} = filterConfig;

						if (multiple) {
							const values = formData.getAll(id);
							for (const value of values) {
								newSearchParams.append(id, value.toString());
							}
						} else {
							const value = formData.get(id);
							if (value && value !== 'all') {
								newSearchParams.set(id, value.toString());
							}
						}
					}

					router.replace(`?${newSearchParams.toString()}`, {scroll: false});
				}}
			>
				{filterConfigs.map((filterConfig) => {
					if (!filterConfig) {
						return null;
					}
					const {id, label, options, multiple = false} = filterConfig;
					return (
						<fieldset key={id}>
							<legend>{label}</legend>
							{multiple ? (
								<div className="flex flex-col gap-2">
									{options.map((option) => (
										<Checkbox
											key={option.value}
											name={`${id}`}
											value={option.value}
											defaultChecked={searchParams
												.getAll(id)
												.includes(option.value)}
											labelProps={{
												className: 'whitespace-nowrap',
											}}
										>
											{option.label}
										</Checkbox>
									))}
								</div>
							) : (
								<Select name={id} defaultValue={searchParams.get(id) ?? 'all'}>
									<option value="all">Alle</option>
									{options.map((option) => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</Select>
							)}
						</fieldset>
					);
				})}
			</form>
		</FilterAccordion>
	);
};

export default ClientFilters;
